import styled from 'styled-components'

const Logo = styled.img`
    width: 40px;
    height: auto;
`

const Container = styled.div``

export const EmojiLogo = ({ src, style }: { src: string; style?: React.CSSProperties }) => {
    return (
        <Container>
            <Logo src={src} style={style} />
        </Container>
    )
}
